import { render, staticRenderFns } from "./TemplateDesignCard.vue?vue&type=template&id=20e88069&scoped=true&"
import script from "./TemplateDesignCard.vue?vue&type=script&lang=ts&"
export * from "./TemplateDesignCard.vue?vue&type=script&lang=ts&"
import style0 from "./TemplateDesignCard.vue?vue&type=style&index=0&id=20e88069&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20e88069",
  null
  
)

export default component.exports